<template>
    <div class="options-wrapper">
        <div class="options-header">
            <div class="options-title">{{ optionTitle }}</div>
            <OptionOperate></OptionOperate>
        </div>
        <div class="options-list">
            <Option
                v-for="option in currentAnswer.options"
                :key="option.uId"
                :data="option"
                v-show="option.itemType != 'labor' && option.updateState != 'delete'"
                @draging="dragHandler"
                :isDraging="isDrag"
            />
            <Button :text="optionTitle" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="addClick" class="add-btn" />
        </div>
        <ConnectedToLabor :data="laborData" v-if="hasImRight" />
    </div>
</template>

<script>
import Option from "./options/Option";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import OptionOperate from "./options/OptionOperate";
import ConnectedToLabor from "./options/ConnectedToLabor";
import { checkModule } from "@/lib/auth";

export default {
    name: "OptionsEdit",
    components: {
        Option,
        Button,
        OptionOperate,
        ConnectedToLabor
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px 0",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px -22px",
            isDrag: false
        };
    },
    computed: {
        currentAnswer() {
            return this.getStorePorp("currentAnswer");
        },
        optionTitle() {
            return this.$t("zhiji.answer.shortcut");
        },
        laborData() {
            let laborData = "";
            this.currentAnswer.options.forEach(data => {
                if (data.itemType == "labor") {
                    laborData = data;
                }
            });

            return laborData;
        },
        hasImRight() {
            return checkModule("im");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        addClick() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addOption"
            });
        },
        dragHandler(flag) {
            this.isDrag = flag;
        }
    }
};
</script>

<style lang="scss" scoped>
.options-wrapper {
    border-top: solid 1px #d8e4f0;
    padding-left: 12px;
    padding-bottom: 42px;

    .options-header {
        display: flex;
        align-items: center;
        padding: 14px 0 12px;

        .options-title {
            font-size: 14px;
            font-weight: bold;
        }
    }

    .options-list {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        max-width: 1025px;
        flex-wrap: wrap;
        align-items: flex-start;
        position: relative;
    }

    .add-btn {
        border-radius: 20px;
        font-size: 12px;
        padding: 0 20px;
        height: 32px;
    }
}
</style>
